/* eslint-disable @typescript-eslint/no-explicit-any */
// Import Types
import type { SchemaDependency } from 'types';

export default class UIHashButtonItem {
    colorUI: any = null;
    comparison: any = null;
    description: any = null;
    displayName: any = null;
    hashKey: any = null;
    hashType: any = null;
    placeholder: any = null;
    uiType: any = null;
    segmentationFilterId: any = null;
    /** Data tables the filter depends on (set for filter rows and filter-group parents). */
    schemaDeps: SchemaDependency[] = [];

    constructor(
        hashKey: any = null,
        hashType: any = null,
        displayName: any = null,
        description: any = null,
        colorUI: any = null,
        comparison: any = null,
        placeholder: any = null,
        uiType: any = null,
        segmentationFilterId: any = null,
    ) {
        this.hashKey = hashKey;
        this.hashType = hashType;
        this.displayName = displayName;
        this.description = description;
        this.colorUI = colorUI;
        this.comparison = comparison;
        this.placeholder = placeholder;
        this.uiType = uiType;
        this.segmentationFilterId = segmentationFilterId;
    }
}
